import React, { useState, useEffect } from "react";
import Calendar from "../Components/MyCalendar";
import axios from "axios";

const Events = () => {
  const sessionId = localStorage.getItem("currentSessionId");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [hoveredDateEvents, setHoveredDateEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) return;

    const fetchEvents = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/events/getEvents/${sessionId}`);
        setEvents(res.data);
      } catch (err) {
        setError("Failed to load events.");
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [sessionId]);

  const handleDateChange = (day) => {
    const newDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), day);
    setSelectedDate(newDate);
  };

  const handleDateHover = (date) => {
    const filtered = events.filter(
      (e) => new Date(e.date).toDateString() === date.toDateString()
    );
    setHoveredDateEvents(filtered);
  };

  const handleDateLeave = () => setHoveredDateEvents([]);

  const highlightDatesWithEvents = (date) => {
    const eventDates = events.map((e) => new Date(e.date).toDateString());
    return eventDates.includes(date.toDateString());
  };

  // Filter events for the **current year** for right panel
  const currentYear = selectedDate.getFullYear();
  const yearlyEvents = events.filter(
    (e) => new Date(e.date).getFullYear() === currentYear
  );

  return (
    <div className="min-h-screen p-2 sm:p-6 lg:p-8 flex flex-col items-center bg-gray-50">
      <div className="flex flex-col lg:flex-row w-full max-w-6xl gap-6">
        {/* Calendar */}
        <div className="w-full lg:w-1/2 bg-white shadow-xl rounded-lg p-4 sm:p-6">
          <h1 className="text-xl sm:text-2xl font-bold mb-4 text-center text-gray-800">
            <i className="md:hidden fas fa-calendar-alt mr-2 text-green-600"></i>
            Event Calendar
          </h1>
          <Calendar
            selectedDate={selectedDate}
            handleDateChange={handleDateChange}
            highlightDatesWithEvents={highlightDatesWithEvents}
            onMonthChange={setSelectedDate}
            handleDateHover={handleDateHover}
            handleDateLeave={handleDateLeave}
          />

          {/* Hovered events */}
          {hoveredDateEvents.length > 0 && (
            <div className="mt-4 p-2 bg-gray-100 rounded-lg shadow-inner max-h-64 overflow-y-auto">
              <h4 className="font-semibold mb-2 text-gray-700">
                Events on {hoveredDateEvents[0] && new Date(hoveredDateEvents[0].date).toDateString()}
              </h4>
              {hoveredDateEvents.map((event) => (
                <div
                  key={event._id}
                  className="mb-2 p-2 bg-blue-50 border-l-4 border-blue-400 rounded"
                >
                  <p className="font-medium text-gray-800">{event.title}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* All events in the year */}
        <div className="w-full lg:w-1/2 bg-white shadow-xl rounded-lg p-4 sm:p-6 max-h-[600px] overflow-y-auto">
          <h2 className="text-lg sm:text-xl font-semibold mb-4 text-gray-800">
            All Events in {currentYear}
          </h2>
          {loading ? (
            <p>Loading events...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : yearlyEvents.length > 0 ? (
            yearlyEvents.map((event, index) => (
              <div
                key={event._id || index}
                className="mb-3 p-3 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition"
              >
                <p className="font-semibold text-gray-700">{event.title}</p>
                <p className="text-gray-500 text-sm">
                  {new Date(event.date).toDateString()}
                </p>
              </div>
            ))
          ) : (
            <p>No events this year.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Events;
